import { ID, WoosatTelecomResponse } from '../../../../../_metronic/helpers'
import { Payment } from '../../../payment/payments-list/core/_models'

export type Balance = {
  id?: ID,
  reseller_id?: string,
  transaction_type?: "credit" | "debit", // Specifies credit or debit type
  payment_id?: string, // Foreign key reference to Payment
  balance_amount?: number, // Balance-specific amount
  currency_id?: string,
  description?: string, // Additional description field specific to Balance
  balance_date?: string,
  balance_status?: "active" | "inactive", // Specifies balance status (customize as needed)
  created_at?: string, // Timestamp for creation
  updated_at?: string, // Timestamp for updates
  payment_method_id?: string,
  payment_amount?: number,
  payment_currency_id?: string,
  transaction_id?: number | null,
  payment_status?: "completed" | "pending" | "failed",
  payment_notes?: string,
  payment_date?: string,
}

export type BalancesQueryResponse = WoosatTelecomResponse<Balance[]>

// Initialize all fields with default values
export const initialBalance: Balance = {
  id: '',
  reseller_id: '',
  transaction_type: "credit", // Default transaction type
  payment_id: '',
  balance_amount: 0,
  currency_id: '',
  description: '',
  balance_date: '',
  balance_status: "active", // Default status (customize as needed)
  created_at: '',
  updated_at: '',
  payment_method_id: '',
  payment_amount: 0,
  payment_currency_id: '',
  transaction_id: null,
  payment_status: "completed", // Default payment status
  payment_notes: '',
  payment_date: '',
}
